import React from "react";
import { CloseIcon } from "@icarius-icons";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import CommonPage from "@icarius-common/commonPage";
import {
  Dialog,
  DialogTitle,
  DialogContent,
} from "@material-ui/core";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import { getLocalizedString } from "@icarius-localization/strings";

const MissingAccountsDialog = (props) => {

  const {
    open,
    data,
    processName,
    handleComplete,
    handleClose,
  } = props;

  const completeButton = (gridRef) => Boolean(data?.length) && (
    <CustomIconButton
      title={getLocalizedString("completeImputations")}
      onClick={() => handleComplete(gridRef)}
    />
  )

  return (
    <Dialog
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      open={open}
      scroll={"paper"}
      fullWidth={true}
      maxWidth={"lg"}
    >
      <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
      <DialogTitle style={{ cursor: 'move', paddingBottom: 0 }} id="draggable-dialog-title">
        {getLocalizedString("missingAccountsTitle", { processName })}
      </DialogTitle>
      <DialogContent>
        <CommonPage
          gridTitle={getLocalizedString("missingAccountsTitle", { processName })}
          columnDefPage={"accountingEntriesMissingAccounts"}
          rowData={data}
          menuItems={[completeButton]}
          gridHeight={"calc(100vh - 245px)"}
          ignoreProcessesbyPath
          hasSelectAll
        />
      </DialogContent>
    </Dialog>
  );
}

export default MissingAccountsDialog;